import {
    IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor, IDeviceNode,
    IDynamicControlsSharedState
} from '../shared/models/device';

import { DeviceService } from '../shared/services/device.service';
import { ElementTypes } from '../shared/models/models';

// Visits an object representing a section within the hardware device
// object model.  When the object is visited, a section is added to
// the current grouping.
export class DeviceSectionVisitor implements IDeviceItemVisitor {

    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        // purposely empty
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        return this.isDeviceSection(propValue);
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let section: IDeviceItemGrouping = propValue as IDeviceItemGrouping;

        section.$isContainer = true;
        section.$categories = [];
        section.$sections = [];
        section.$controlInputs = [];

        this.currentGrouping.$sections.push(section);
        return section; // Make the current grouping.
    }

    private isDeviceSection(propValue: IDeviceNode) {
        return propValue !== null &&
            typeof propValue === 'object' &&
            propValue.elementType === ElementTypes.DeviceSection &&
            !this.isGroupOfSimilarInputs(propValue);
    }

    private isGroupOfSimilarInputs(propValue: IDeviceNode): boolean {
        return propValue['displayText'] === 'Value';
    }
}
